module.exports = __webpack_public_path__ + "img/14.b9a2c82f.jpg";